<template>
  <div class="text-center">
    <img
      src="../assets/img/Check.png"
      alt="Sukses"
      srcset=""
      class="m-auto mb-5"
    />
    <h1><slot /></h1>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>